import eyeIcon from './../Assets/icons/eye 1.svg'
import editIcon from './../Assets/icons/Un-Checkbox.svg'

export const TABLE_HEADERS = [
    // "Sr No.",
    "Dealer Name",
    "Claim Code",
    "Claim Name",
    
    "Created At",
  //  "Item Image",
    "Remark",
    // "Status",
    // "OEM Item Status",
    "Claim Status",
    "Action"

  ];
  
  export const TABLE_DATA = [
    { id: 1, days: "One Month", description:"lorem ipsum",status: "Active", actions: "Edit/Delete" },
    { id: 2, days: "Two Month", description:"lorem ipsum",  status: "Inactive", actions: "Edit/Delete" },
    { id: 3, days: "Three Month", description:"lorem ipsum",  status: "Active", actions: "Edit/Delete" },
  ];
  
  export const keyMapping = {
    // "Sr No.": "Sr No.",
    "Dealer Name": "dealer_name",
    "Claim Code":'claimCode',
    "Claim Name":"claimName",
    "Warranty Name":"warrrenty_name", 
    "Warrenty Type":"warrantyType",
    "Warranty Days":"warrantyDay",
   "Created At":"createdAt",
   "Item Image":"imagepath",
    "OEM Item Status":"itemstatus",
    "Claim Status": "status",
    "Remark":"remark",  
    "Status": "repairStatus", 
    "Action": [
        { type: "view", icon: eyeIcon, label: "View" },
        
      ]
  };